import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import api from "../../api/api";
import { combinedproviders } from "../combinedproviders";
import { getPracticeId } from "../../config/practice";

const ProvidersPopup = ({ isOpen, getproviders, onClose }) => {
  const [selectedNames, setSelectedNames] = useState([]); // Store selected button names
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false); // Track loading state
  const practiseid = getPracticeId();

  const fetchdata = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200) {
        
        setProviders([...response.data,...combinedproviders]);
      } else {
        setProviders([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchdata();
    }
  }, [isOpen]);

  const handleButtonClick = (name) => {
    setSelectedNames((prevSelectedNames) => {
      if (prevSelectedNames.includes(name)) {
        return prevSelectedNames.filter((selectedName) => selectedName !== name);
      } else {
        return [...prevSelectedNames, name];
      }
    });
  };

  const handleSelectAllChange = () => {
    const selectedString = selectedNames.join("/");
    getproviders(selectedString); // Update the string state
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        {/* Popup Box */}
        <div className="relative flex flex-col gap-4 w-[386px] bg-white  pb-6 rounded-lg shadow-lg text-left">
          <div>
            <div className="w-full flex items-center justify-between mt-2 px-4 py-2">
              {/* Close Button */}
              <span className="ml-2 font-semibold font-Font1 text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Providers
              </span>
              <button
                className="text-gray-500 hover:text-gray-700 text-[30px]"
                onClick={onClose}
              >
                &times;
              </button>
            </div>
            <div className="h-px bg-[#D0D5DD]"></div>
          </div>

          <div className="flex flex-wrap gap-4 p-4 max-h-[50vh] overflow-auto custom-scrollbar">
            {loading
              ? [...Array(6)].map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="rectangular"
                    width={100}
                    height={40}
                    sx={{ borderRadius: "20px" }}
                  />
                ))
              : providers.map((provider, index) => (
                  <button
                    key={index}
                    onClick={() => handleButtonClick(provider?.providername)}
                    className={`rounded-full text-sm font-Font1 border-[1.5px] border-gray-200 py-2 px-4 transition duration-300 ease-in-out 
                    ${
                      selectedNames.includes(provider?.providername)
                        ? "bg-[#E17954]  hover:bg-[#E88D67E5] text-white"
                        : "bg-[white] text-[#1D2951] hover:bg-[#F3F4F6]"
                    } 
                   `}
                  >
                    {provider?.providername}
                  </button>
                ))}
          </div>

          <div className="w-full flex justify-center bg-[#F3F4F6]  border-t">
            {loading ? (
              <Skeleton
                variant="rectangular"
                width="40%"
                height={40}
                sx={{ borderRadius: "20px" }}
              />
            ) : (
              <button
                onClick={handleSelectAllChange}
                className="rounded py-2  font-[12px] mt-3  font-inter w-[90%] transition duration-300 ease-in-out  bg-[#18181B] hover:bg-[#18181BE5] text-[#FFFFFF]"
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ProvidersPopup;
